import { ncBannerOptions } from "../../interface/ICommonbanner";

interface templateInterface{
    (_data:ncBannerOptions): void;
}

interface setStartEnd{
    startDate?:string;
    endDate?:string;
    startTime?:string;
    endTime?:string;
}

export const setStartEndDateTime = (_data: ncBannerOptions, _nowData:setStartEnd ,template: templateInterface) => {   
    
    if(_nowData.startDate || _nowData.endDate){               
                    
        let startYears:string | undefined;
        let startMonths:string | undefined;  
        let startDays:string | undefined;   
        let startHours:string | undefined;   
        let startMinutes:string | undefined;
        let endYears:string | undefined;
        let endMonths:string | undefined;  
        let endDays:string | undefined;   
        let endHours:string | undefined;   
        let endMinutes:string | undefined;

        if(_nowData.startDate){                        
            startYears = _nowData.startDate?.substring(0,4);
            startMonths = _nowData.startDate?.substring(5,7);
            startDays = _nowData.startDate?.substring(8,10);
            if(_nowData.startTime){
                startHours = _nowData.startTime?.substring(0,2);
                startMinutes = _nowData.startTime?.substring(3,5);   
            }else{                
                return;
            }                               
        }
        if(_nowData.endDate){                        
            endYears = _nowData.endDate?.substring(0,4);
            endMonths = _nowData.endDate?.substring(5,7);
            endDays = _nowData.endDate?.substring(8,10);
            if(_nowData.endTime){
                endHours = _nowData.endTime?.substring(0,2);
                endMinutes = _nowData.endTime?.substring(3,5);      
            }else{                
                return;
            }                                     
        }                                   
        
        const startday = new Date(`${startYears}-${startMonths}-${startDays}T${startHours}:${startMinutes}:00+09:00`).getTime();    
        const endday = new Date(`${endYears}-${endMonths}-${endDays}T${endHours}:${endMinutes}:00+09:00`).getTime();   
        const today = new Date(window.userData.now).getTime();                     
        
        const startResult = (startday - today) < 0;  
        const endResult = (endday - today) < 0;        

        if(startday > endday){           
            return;
        }

        if(startResult){
            if(endResult){                        
                return;
            }                          
            template(_data); 
        }else{                  
            if(!isNaN(endday) && !endResult){                             
                if(!isNaN(startday)){                            
                    return;
                }else{                     
                    template(_data); 
                }                         
            }
        }                 
    }else{        
        template(_data);    
    }
       
}